import type { RouteLocationNormalized, Router } from "vue-router";
import { redirectToLogin } from "@/utils/redirectUtil";
import { UserRole } from "@/models/userRole";
import { STORES } from "@/services/infrastructure/storageService";
import { localStorageService } from "@/services/infrastructure/localstorageService";
import { User } from "@/models/user";


export const authenticationGuard = (router: Router): void => {
  router.beforeResolve(async (to: RouteLocationNormalized) => {
    const token = localStorageService.getItem("token");
    
    const isUserAuthenticated = !!token;

    const currentUser = localStorageService.getItem<User>(STORES.user);
    if (isUserAuthenticated && to.meta.requiresGroupManager && !currentUser?.isGroupManager) {
      return { name: "default" };
    }
    if (isUserAuthenticated && to.meta.requiresAdministrator && currentUser?.role !== UserRole.Administrator) {
      return { name: "accounts-admin-required" };
    }
    if (to.meta.requiresItManager && currentUser?.role !== UserRole.ITManager) {
      return { name: "accounts-admin-required" };
    }

    if (isUserAuthenticated && isUserAuthenticated && to.path === "/accounts/login") {
      return { path: "/app" }; // Redirect authenticated users to main page
    }

    if (to.meta.requiresAuth && !isUserAuthenticated) {
      redirectToLogin(to.fullPath);
      return false;
    }
    
    return true;
  });
};
